import { api } from "./api";

// Télémétrie client → POST /api/tuluss/activity (Fabric MARKETPLACE, apprentissage TULUSS).
// Fire-and-forget : jamais bloquant, n'émet jamais d'erreur vers l'UI. Minimisation : aucune PII.
// Anti-doublon léger : un même (kind + réf) n'est pas renvoyé 2x en moins de 1,5 s.
let _lastKey = null;
let _lastAt = 0;

export const logActivity = (kind, extra = {}) => {
  try {
    const key = `${kind}:${extra.product_id || extra.path || extra.query || ""}`;
    const now = Date.now();
    if (key === _lastKey && now - _lastAt < 1500) return;
    _lastKey = key;
    _lastAt = now;
    api.post("/tuluss/activity", { kind, ...extra }).catch(() => {});
  } catch {
    /* jamais bloquant */
  }
};
